import React from 'react';
import PropTypes from 'prop-types';

import Card from '@material-ui/core/Card';

import IndentedCardContent from '../../../../components/IndentedCardContent/IndentedCardContent';
import TenancyInformationCard from './TenancyInformationCard/TenancyInformationCard';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

class TenancyInformationSection extends React.Component {
  render() {
    const { classes, name, reference, tenancyData } = this.props;

    return (
      <div className={classes.root}>
        <Card>
          <IndentedCardContent
            body={
              <div className={classes.bodyContainer}>
                <TenancyInformationCard
                  name={name}
                  reference={reference}
                  address={
                    tenancyData.hasOwnProperty('currentTenancy') &&
                    tenancyData.currentTenancy.hasOwnProperty('propertyAddress')
                      ? tenancyData.currentTenancy.propertyAddress
                      : ''
                  }
                  tenancyStatus={
                    tenancyData.hasOwnProperty('currentTenancy') &&
                    tenancyData.currentTenancy.hasOwnProperty('tenantStatus')
                      ? tenancyData.currentTenancy.tenantStatus
                      : ''
                  }
                  tenancyStart={
                    tenancyData.hasOwnProperty('currentTenancy') &&
                    tenancyData.currentTenancy.hasOwnProperty('tenancyStart')
                      ? tenancyData.currentTenancy.tenancyStart
                      : ''
                  }
                  tenancyEnd={
                    tenancyData.hasOwnProperty('currentTenancy') &&
                    tenancyData.currentTenancy.hasOwnProperty('tenancyEnd')
                      ? tenancyData.currentTenancy.tenancyEnd
                      : ''
                  }
                  tenancyManager={
                    tenancyData.hasOwnProperty('currentTenancy') &&
                    tenancyData.currentTenancy.hasOwnProperty('tenancyManager')
                      ? tenancyData.currentTenancy.tenancyManager
                      : ''
                  }
                />
              </div>
            }
            noIndent={true}
          />
        </Card>
      </div>
    );
  }
}

TenancyInformationSection.propTypes = {
  classes: PropTypes.object.isRequired,
};

TenancyInformationSection.defaultProps = {};

export default withStyles(styles)(TenancyInformationSection);
